import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { TRANSFER_ROUTE_PATHS } from './config';

export const TRANSFER_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-tp-transfers',
    path: TRANSFER_ROUTE_PATHS.transfers,
    component: lazy(() => import('./pages/transfers-page')),
    layout: 'default',
    permissions: { scopes: ['movements-tp-transfers', 'movements-transfer-platform-transfers'] },
    menu: {
      title: 'Transfer Platform Transfers',
    },
  },
  {
    id: 'movements-tp-transfers-batch',
    path: TRANSFER_ROUTE_PATHS.batch,
    component: lazy(() => import('./pages/transfers-batch-page')),
    layout: 'default',
    permissions: { scopes: ['movements-tp-transfers', 'movements-transfer-platform-transfers'] },
  },
];
